// extracted by mini-css-extract-plugin
export var container = "Interviews-module--container--87c9a";
export var organizer = "Interviews-module--organizer--67822";
export var sliderWrapper = "Interviews-module--sliderWrapper--fede2";
export var layout = "Interviews-module--layout--9ab15";
export var subtitle = "Interviews-module--subtitle--f886d";
export var slide = "Interviews-module--slide--28a61";
export var animation = "Interviews-module--animation--6455a";